import React from 'react';
import './Pages.css';

const Terms = () => {
  return React.createElement(
    'main',
    { className: 'page-content' },
    React.createElement(
      'div',
      { className: 'container' },
      React.createElement('h1', null, 'Terms & Conditions'),
      React.createElement('p', null, 'Welcome to InfoNaukri. By using our services, you agree to the following terms and conditions...'),
      React.createElement('h3', null, '1. Acceptance of Terms'),
      React.createElement('p', null, 'By accessing this website, you agree to be bound by these terms of service...'),
      React.createElement('h3', null, '2. Services'),
      React.createElement('p', null, 'InfoNaukri provides E-Profile creation, career services, and interview preparation...'),
      React.createElement('h3', null, '3. User Obligations'),
      React.createElement('p', null, 'Users must provide accurate information and maintain the confidentiality of their accounts...')
    )
  );
};

export default Terms;